import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const taxPreview = css`
  margin-bottom: 20px;
  padding: 0 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
`;

export const link = css`
  color: ${withVar(DesignToken.ActionPrimaryDefault)};
  font-size: 14px;
  cursor: pointer;
`;
